export function checkReviewPermissionWithUser (row, user) {
  if ([1, 2, 3, 4, 13, 14].includes(row.status)) { // 待各级审批
    if (user.usertype * 1 === 1) { // 超管
      return true
    } else { // 各级审批人
      const userId = user.id * 1
      if (row.status === 1) {
        return row.first_approver * 1 === userId
      } else if (row.status === 2) {
        return row.second_approver * 1 === userId
      } else if (row.status === 3) {
        return row.third_approver * 1 === userId
      } else if (row.status === 4) {
        return row.fourth_approver * 1 === userId
      } else if (row.status === 13) {
        return row.department_approver * 1 === userId
      } else if (row.status === 14) {
        return row.special_approver * 1 === userId
      }
    }
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/views/payment-manager/payment-manager-check-permission.js